import type ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { LoggerInterface } from "@interfaces/LoggerInterface";

import { SelectValueParamsWithoutSchema } from "../types";

class StorefrontValuesGrowaveApiService {
    constructor(
        private readonly logger: LoggerInterface,
        private readonly apiClient: ApiClientInterface
    ) {}

    public selectStorefrontValues({
        namespace,
        key,
    }: SelectValueParamsWithoutSchema): Observable<unknown> {
        this.logger.debug(
            "StorefrontValuesGrowaveApiService.getStorefrontValues is started"
        );

        return this.apiClient
            .get({
                url: "/getStorefrontValues",
                responseType: "json",
                queryParams: {
                    selectors: [`${namespace}:${key}`],
                },
            })
            .pipe(
                map((response) => response.body),
                catchError((error: unknown) => {
                    this.logger.debug(
                        "StorefrontValuesGrowaveApiService.getStorefrontValues is errored",
                        error
                    );
                    throw error;
                })
            );
    }
}

export default StorefrontValuesGrowaveApiService;
